export const state = {
  layoutScrollable: false,
  loader: false,
  browserMode: 'web'
}

export const getters = {}

export const mutations = {
  CHANGE_LAYOUT_POSITION(state, layoutScrollable) {
    state.layoutScrollable = layoutScrollable
  },
  LOADER(state, loader) {
    state.loader = loader
  },
  BROWSER_MODE(state, browserMode) {
    state.browserMode = browserMode
  }
}

export const actions = {
  changeLayoutPosition({ commit }, { layoutScrollable }) {
    commit('CHANGE_LAYOUT_POSITION', layoutScrollable);
  },
  changeLoaderValue({ commit }, { loader }) {
    commit('LOADER', loader)
  },
  changeBrowserMode({ commit }, { browserMode }) {
    commit('BROWSER_MODE', browserMode);
  }
}
